import { render, staticRenderFns } from "./VPageSwiper.vue?vue&type=template&id=32bb8e83&scoped=true"
import script from "./VPageSwiper.vue?vue&type=script&lang=ts"
export * from "./VPageSwiper.vue?vue&type=script&lang=ts"
import style0 from "./VPageSwiper.vue?vue&type=style&index=0&id=32bb8e83&prod&lang=scss&scoped=true"
import style1 from "./VPageSwiper.vue?vue&type=style&index=1&id=32bb8e83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bb8e83",
  null
  
)

export default component.exports